import React,{ useEffect, useState } from "react";
import axios from "axios";

const CheckParameter = ({ previousStep,previousValue,triggerNextStep,step,steps,datas }) => {
    console.log("checkparam");
    console.log(previousStep.message);
    console.log({datas});
    console.log(datas.ParameterName);
    console.log(datas.CompareType);
    console.log(datas.Value);
    console.log(datas.Separator);

    // const currDate = new Date();
    // const date = `${currDate.getDate()}/${currDate.getMonth()+1}/${currDate.getFullYear()}`;
    // console.log(date);
    
    const[msg, setMsg]=useState("");
    useEffect(()=>{
        const myArray = datas.Value.split(datas.Separator);
            console.log("CHECKPARAMETER : ", myArray);
        if(datas.CompareType=='NotIn'){
            if(myArray.includes(previousStep.message)){
                triggerNextStep({ value: "Invalid "+datas.ParameterName,trigger: datas.False});
                //triggerNextStep({ value: "Invalid "+datas.ParameterName,trigger: datas.False });
                setMsg("Invalid "+datas.ParameterName);
            }else{
                triggerNextStep({ value: "Invalid name",trigger: datas.True });
                setMsg("ok");
            }
        }

        if(datas.CompareType=='In'){
            if(myArray.includes(previousStep.message)){
                triggerNextStep({ value: "Invalid name",trigger: datas.True });
                setMsg("ok");
            }else{
                triggerNextStep({ value: "Invalid "+datas.ParameterName,trigger: datas.False });
                //triggerNextStep({ value: "Invalid "+datas.ParameterName,trigger: datas.False });
                setMsg("Invalid "+datas.ParameterName);
            }
        }

        if(datas.CompareType=='Equal'){
            if(myArray.includes(previousStep.message)){
                triggerNextStep({ value: "Invalid name",trigger: datas.True });
                setMsg("ok");
            }else{
                triggerNextStep({ value: "Invalid "+datas.ParameterName,trigger: datas.False });
                //triggerNextStep({ value: "Invalid "+datas.ParameterName,trigger: datas.False });
                setMsg("Invalid "+datas.ParameterName);
            }
        }
        
    },[]);
    
    return (
        <div>
            
        {msg}
        </div>
        
    );
   
};
export default CheckParameter;